export const eventIds = {
  TAKE_YOUR_QUIZ: "take_your_quiz",
  NEXT: "next",
  SKIP: "skip",
  PREVIOUS: "previous",
  CLOSE: "close",
  CONTINUE: "continue",
  ANSWER_SELECTED: "answer_selected",
}

const eventInfo = {
  [eventIds.TAKE_YOUR_QUIZ]: {
    clickInternalLinks: "true",
    internalLinkPosition: "intro section",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "take your quiz",
    eventName: "mirror quiz:start",
    internalLinkType: "CTA",
    eventType: "button",
    eventAction: "mirror quiz:start",
  },
  [eventIds.NEXT]: {
    clickInternalLinks: "true",
    internalLinkPosition: "question section",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "next question",
    eventName: "mirror quiz:next",
    internalLinkType: "navigation",
    eventType: "button",
    eventAction: "mirror quiz:next",
  },
  [eventIds.SKIP]: {
    clickInternalLinks: "true",
    internalLinkPosition: "question section",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "skip question",
    eventName: "mirror quiz:skip",
    internalLinkType: "navigation",
    eventType: "button",
    eventAction: "mirror quiz:skip",
  },
  [eventIds.PREVIOUS]: {
    clickInternalLinks: "true",
    internalLinkPosition: "question section",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "previous question",
    eventName: "mirror quiz:previous",
    internalLinkType: "navigation",
    eventType: "button",
    eventAction: "mirror quiz:previous",
  },
  [eventIds.CLOSE]: {
    clickInternalLinks: "true",
    internalLinkPosition: "quiz header",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "close quiz",
    eventName: "mirror quiz:close",
    internalLinkType: "icon",
    eventType: "button",
    eventAction: "mirror quiz:close",
  },
  [eventIds.CONTINUE]: {
    clickInternalLinks: "true",
    internalLinkPosition: "final question",
    internalLinkZoneName: "mirror quiz",
    internalLinkURL: "n/a",
    internalLinkName: "continue",
    eventName: "mirror quiz:complete",
    internalLinkType: "CTA",
    eventType: "button",
    eventAction: "mirror quiz:complete",
  },
  [eventIds.ANSWER_SELECTED]: (qid, aid, qTxt, aTxt) => {
    return {
      clickInternalLinks: "true",
      internalLinkPosition: `question ${qid}`,
      internalLinkZoneName: "mirror quiz",
      internalLinkURL: "n/a",
      internalLinkName: "select answer",
      eventName: "mirror quiz:answer",
      internalLinkType: "radio button",
      eventType: "option",
      eventAction: "mirror quiz:answer",
      questionId: `q${qid}`,
      questionText: qTxt,
      answerId: `a${aid}`,
      answerText: aTxt,
    }
  },
}

const getPageInfo = () => {
  if (window && window.adobeDataLayer) {
    const state = window.adobeDataLayer.getState("page")
    return {
      site: state.site,
      pageInfo: state.pageInfo,
      category: {
        ...state?.category,
        subCategory2: "quiz",
        pageType: "interactive",
        subCategory1: "mirror",
        subCategoryID: "quiz-mirror",
      },
    }
  }
}

export const quizAnalytics = (eventId, ...args) => {
  if (window && window.adobeDataLayer) {
    const event = eventInfo[eventId]
    if (event) {
      window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: typeof event === "function" ? event(...args) : event,
        page: getPageInfo(),
      })
    } else {
      console.warn(`No analytics info found for eventId: ${eventId}`)
    }
  }
}
